import React, { useContext } from 'react';
import AgbaContext from '../../context/agba/agbaContext';
import AboutLayout from '../../layoutComponents/about/AboutLayout';
import { TagDiv } from '../TagPageStyle';

const AboutPage = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar } = agbaContext;
  return (
    <TagDiv sideBar={sideBar}>
      <div className='page'>
        <AboutLayout />
      </div>
    </TagDiv>
  );
};

export default AboutPage;
